import React from 'react'
import './Hero.css'

export const Hero = () => {
  return (
    <div className='Hero' id='home'>
        <div className="hero-text">
            <span>Building digital apps and products </span>
            <span>of Tomorrow</span>
           <span>Collaborate with our team of industry experts and brand managers to take your digital journey from</span>
           <span>  idea generation to promotion and furtherance</span>

        </div>
        <div className="hero-buttons">
            <div className="btn btn-primary">Book a Call</div>
            <div className="btn ">Learn More </div>
        </div>

    </div>
  )
}
